/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
import {ArtifactoryDao} from '../../artifactory_dao';

export class ArtifactBuildsDao extends ArtifactoryDao {

    constructor($resource, RESOURCE,artifactoryNotificationsInterceptor) {
        super($resource, RESOURCE,artifactoryNotificationsInterceptor);

        this.setPath(RESOURCE.ARTIFACT_BUILDS);
        this.setCustomActions({
            'query': {
                isArray: false
            },
            'getJson': {
                path: RESOURCE.ARTIFACT_BUILDS + '/json',
                transformResponse: (data) => {
                    return {json: data};
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./data/dao/artifact/artifact_builds_dao.js